import { ReactNode } from 'react';
import { INotification } from './notification.interface';

export enum NotificationsActionType {
    ADD_NOTIFICATION = 'ADD_NOTIFICATION',
    REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION',
    UPDATE_NOTIFICATION_MESSAGE = 'UPDATE_NOTIFICATION_MESSAGE',
}

export type NotificationAction =
    | {
          type: NotificationsActionType.ADD_NOTIFICATION;
          payload: { notification: INotification };
      }
    | {
          type: NotificationsActionType.REMOVE_NOTIFICATION;
          payload: { notificationId: string };
      }
    | {
          type: NotificationsActionType.UPDATE_NOTIFICATION_MESSAGE;
          payload: { notificationId: string; notificationMessage: ReactNode };
      };
